import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { GameProvider } from './state/GameContext.js';
import { RouterProvider } from './state/RouterContext.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable.');

createRoot(root).render(<ErrorBoundary><RouterProvider><GameProvider><App /></GameProvider></RouterProvider></ErrorBoundary>);
